import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import Typography from "@insite/mobius/Typography";
import React, {useEffect, useRef} from "react";
import styled from "styled-components";

type SectionsProps = { title?: string; children: React.ReactNode; shouldFocus?: Boolean };


export const Section: React.FC<SectionsProps> = ({ title, children, shouldFocus = false }) => {

    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if(shouldFocus && sectionRef?.current){
            sectionRef.current.focus();
        }
    }, []);

    return(
        <SectionContainer ref={sectionRef} tabIndex={-1}>
            {title && <SectionTitle variant="h2">{title}</SectionTitle>}
            {children}
        </SectionContainer>
    );
};

export const SectionContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${styleHelpers.rem(20)};
    padding: ${styleHelpers.rem(20)} 0;
    background-color: ${styleConstants.colours.white};
    z-index: 0;
    &:focus{
        outline: 0;
    }
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0 calc((100% - 100vw) / 2);
        width: 100vw;
        height: 100%;
        z-index: -1;
        display: block;
        content: "";
        background-color: ${styleConstants.colours.white};
        box-shadow: 3px 6px 40px 0px rgba(0, 0, 0, 0.1);
    }
    @media (min-width: ${styleHelpers.breakpointWidth("md")}) {
        padding: ${styleHelpers.rem(30)};
        gap: ${styleHelpers.rem(30)};
        border-radius: ${styleHelpers.rem(10)};
        box-shadow: 3px 6px 40px 0px rgba(0, 0, 0, 0.1);
        &::before {
            display: none;
        }
    }
    @media (min-width: ${styleHelpers.breakpointWidth("lg")}) {
        border-radius: ${styleHelpers.rem(15)};
        padding: ${styleHelpers.rem(40)};
    }
`;

const SectionTitle = styled(Typography)`
    font-size: ${styleHelpers.rem(22)};
    margin: 0;
    @media (min-width: ${styleHelpers.breakpointWidth("lg")}) {
        margin: 0;
        font-size: ${styleHelpers.rem(26)};
    }
`;
